export enum EMapMarkerType {
  LOADING = 'loading',
  UNLOADING = 'unloading',
  CUSTOM = 'custom',
  WAREHOUSE = 'warehouse',
  EXTERNAL_WAREHOUSE = 'external-warehouse',
  ANONYMOUS = 'anonymous',
}
